export enum FormQuestionDeleteOptions {
    Delete = 1,
    MarkAsDisabled = 2,
}
